import { render, staticRenderFns } from "./orderPayManager.vue?vue&type=template&id=6e921dec&scoped=true"
import script from "./orderPayManager.vue?vue&type=script&lang=ts"
export * from "./orderPayManager.vue?vue&type=script&lang=ts"
import style0 from "./orderPayManager.vue?vue&type=style&index=0&id=6e921dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e921dec",
  null
  
)

export default component.exports